/** Moeda única da loja — não há campo de moeda na configuração do tenant. */
export const CURRENCY = "BRL";

/** Normaliza valor monetário para número com 2 casas (CA-14). */
export function money(value) {
  const numero = Number(value ?? 0);
  if (!Number.isFinite(numero)) {
    return 0;
  }
  return Math.round(numero * 100) / 100;
}

/** Preço efetivamente cobrado — o mesmo critério do OrderFactory. */
function precoEfetivo(item) {
  return money(item?.promotionalPrice || item?.price || 0);
}

/** Monta um item do payload a partir do item da loja (CA-2, CA-14). */
export function itemPayload(item, quantity = 1) {
  return {
    item_id: item?.id,
    item_name: item?.name,
    price: precoEfetivo(item),
    quantity: Number(quantity) || 0,
    item_category: item?.categories?.[0]?.name,
  };
}

/** Monta a lista de itens a partir do carrinho (CA-5, CA-6, CA-7). */
export function cartItemsPayload(cart) {
  return (cart?.items ?? []).map(({ item, quantity }) =>
    itemPayload(item, quantity)
  );
}

/** Parâmetros de `view_item` (CA-2). */
export function viewItemParams(item) {
  const payload = itemPayload(item, 1);
  return {
    currency: CURRENCY,
    value: payload.price,
    items: [payload],
  };
}

/**
 * Parâmetros dos eventos de carrinho e checkout (CA-5, CA-6, CA-7).
 *
 * O total vigente é o que o cliente vê: com regras de desconto quando a loja
 * as tem ativas, senão o total simples. Sem essa precedência, `view_cart` e
 * `begin_checkout` reportariam valores diferentes para o mesmo carrinho.
 */
export function cartParams(cart, extra) {
  return {
    currency: CURRENCY,
    value: money(cart?.totalWithDiscountRules ?? cart?.total),
    items: cartItemsPayload(cart),
    ...(extra ?? {}),
  };
}

/** Parâmetros de `purchase` — sem nenhum dado do cliente (CA-8, CA-15). */
export function purchaseParams(order) {
  const params = {
    currency: CURRENCY,
    transaction_id: String(order?.orderId ?? ""),
    value: money(order?.total),
    shipping: money(order?.shipping),
    items: cartItemsPayload(order?.cart),
  };
  if (order?.coupon) {
    params.coupon = order.coupon;
  }
  return params;
}
